import "./CSS_styles/heading.css";
import "./CSS_styles/home2d-sections.css";
import ShimmerBackground from "./Shimmer.jsx";
import useSectionTracker from "./useSectionTracker";
import { useState } from "react";
import BlobBackground from "./BlobBackground";

export default function Home2D() {
  useSectionTracker(["about", "skills", "ai-fun", "contact"]);

  // Contact form state
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactMessage, setContactMessage] = useState("");
  const [contactLoading, setContactLoading] = useState(false);

  const emailApiUrl = process.env.REACT_APP_EMAIL_API_URL || "/api/send-email";

  const handleSendEmail = async () => {
    if (!contactName || !contactEmail || !contactMessage) {
      alert("Please fill in all fields");
      return;
    }

    setContactLoading(true);

    try {
      const res = await fetch(emailApiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          name: contactName, 
          email: contactEmail, 
          message: contactMessage 
        })
      });

      const data = await res.json();

      if (data.status === 'sent') {
        alert("Email sent! 🎉");
        setContactName("");
        setContactEmail("");
        setContactMessage("");
      } else {
        alert("Error sending email");
      }
    } catch (error) {
      alert("Error sending email: " + error.message);
      console.error(error);
    } finally {
      setContactLoading(false);
    }
  };

const bgWords = [
  { word: "CODE",     top: "5%",  left: "2%",   rotate: "0deg",   size: "80px" },
  { word: "DEVELOP",  top: "8%",  left: "55%",  rotate: "90deg",  size: "64px" },
  { word: "DESIGN",   top: "20%", left: "80%",  rotate: "0deg",   size: "72px" },
  { word: "CODE", top: "30%", left: "5%",  rotate: "0deg", size: "56px" },
  { word: "DEEPDIVE", top: "30%", left: "15%",  rotate: "-90deg", size: "56px" },
  { word: "CODE",    top: "40%", left: "70%",  rotate: "0deg",   size: "60px" },
  { word: "CODE",   top: "50%", left: "40%",  rotate: "90deg",  size: "60px" },
  { word: "DEBUG",    top: "60%", left: "5%",   rotate: "0deg",   size: "76px" },
  { word: "LEAD",     top: "65%", left: "60%",  rotate: "-90deg", size: "75px" },
  { word: "CODE",     top: "75%", left: "30%",  rotate: "0deg",   size: "68px" },
  { word: "DEPLOY",   top: "80%", left: "75%",  rotate: "90deg",  size: "70px" },
  { word: "BUILD",    top: "88%", left: "10%",  rotate: "-90deg", size: "80px" },
  { word: "DEVELOP",  top: "90%", left: "50%",  rotate: "0deg",   size: "70px" },
];

  return (
    <div className="home2d-page">

    <div className="global-bg-layer">
  <BlobBackground
    bgColor="transparent"
    lineColor="#aaaaaa"
    speed={1}
    blobSize={300}
    blobCount={6}
    opacity={0.5}
  />
  {bgWords.map((w, i) => (
    <span key={i} style={{
      position:     "absolute",
      top:          w.top,
      left:         w.left,
      fontSize:     w.size,
      fontWeight:   900,
      fontFamily:   "Inter, sans-serif",
      color:        "transparent",
      WebkitTextStroke: "1px rgba(0,0,0,0.08)",
      transform:    `rotate(${w.rotate})`,
      whiteSpace:   "nowrap",
      letterSpacing: "0.05em",
      userSelect:   "none",
    }}>
      {w.word}
    </span>
  ))}
</div>

      {/* FIRST VIEW */}
      <section className="hero-welcome" data-section="home">
        <div className="hero-inner">
          <h1 className="hero-title">
            ANKITH. R </h1> <br/>
            <div className="hero-echo-wrap">
  {[...Array(7)].map((_, i) => {
    const y = i * 22;
    const scaleX = 1 - i * 0.04;
    const scaleY = 1 - i * 0.14;

    return (
      <div
        key={i}
        className="hero-echo"
        style={{
          opacity: i === 0 ? 1 : Math.max(0, 0.55 - i * 0.08),
          transform: `translateY(${y}px) scale(${scaleX}, ${Math.max(scaleY, 0.9)})`,
          filter: i === 0 ? "none" : `blur(${i * 0.8}px)`,
          zIndex: 10 - i,
        }}
      >
        WELCOMES YOU
      </div>
    );
  })}
</div>   
<p><em>(Switch to 3D mode on a desktop for the best interactive experience.)</em></p>

   <br/> <br/>  

<p className="explain-web">
  <span
    className="ew-accent"
    data-text="THIS WEBSITE"
    style={{ "--letters": 12 }}
  >
    THIS WEBSITE
  </span>{" "}
  <span className="ew-hover">IS BUILT DIFFERENT.</span>{" "}
  <span className="ew-hover">DESIGNED TO BE</span>{" "}
  <span
    className="ew-accent"
    data-text="FELT."
    style={{ "--letters": 5 }}
  >
    FELT.
  </span>
  <br />
  <span className="ew-hover">A LIVING</span>{" "}
  <span
    className="ew-accent"
    data-text="INTERACTIVE"
    style={{ "--letters": 11 }}
  >
    INTERACTIVE
  </span>{" "}
  <span className="ew-hover">PLAYGROUND</span>{" "}
  <span
    className="ew-accent"
    data-text="OF MOTION"
    style={{ "--letters": 9 }}
  >
    OF MOTION
  </span>
  <span className="ew-hover"> MODE SHIFTS, AND</span>{" "}
  <span
    className="ew-accent"
    data-text="PROJECTS."
    style={{ "--letters": 9 }}
  >
    PROJECTS.
  </span>
  <br />
  <span className="ew-hover">EXPLORE.</span>{" "}
  <span className="ew-hover">SWITCH.</span>{" "}
  <span className="ew-hover">HOVER.</span>{" "}
  <span className="ew-hover">CLICK.</span>{" "}
  <span
    className="ew-accent ew-green"
    data-text="EXPERIENCE."
    style={{ "--letters": 11 }}
  >
    EXPERIENCE.
  </span>
</p>
         
        </div>
      </section>

      {/* ABOUT */}
      <section className="content-section about-section" data-section="about">
        <ShimmerBackground />
      </section>

      {/* SKILLS */}
      <section className="content-section skills-section" data-section="skills">
        <div className="section-card skills-card">
          <h2 className="section-title">SKILLS</h2>
          <div className="skills-grid">
            {[
              "Java", "React JS", "JavaScript", "Python", "SQL", "C++", "TypeScript", "PyTorch",
              "LLMs", "RAG", "Agentic AI", "HuggingFace", "LangChain", "NoSQL", "Node.js",
              "Three.js / WebGL", "Go", "Spring Boot", "GraphQL", "Docker", "Kubernetes",
              "Kafka", "GCP", "AWS", "CSS", "Rest APIs", "Redis", "Cassandra", "PostgreSQL", "GitHub"
            ].map((skill) => (
              <div className="skill-square" key={skill}>
                <div className="skill-inner">
                  <span className="skill-label">{skill}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROJECTS */}
      <section className="content-section ai-section" data-section="ai-fun">
        <div className="section-card ai-shell">
          <h2 className="section-title">Projects </h2>
          

          <div className="ai-fun-layout">

            {/* Tile 1 — GitHub Repo */}
            <div className="ai-tile">
              <div className="ai-tile-left">
                <a 
                  href="https://github.com/Ankith5R" 
                  target="_blank" 
                  rel="noreferrer"
                  className="placeholder-pill vision-demo-pill"
                  style={{cursor: "pointer", textDecoration: "none"}}
                >
                  GitHub <br/>   <span style={{ fontSize: "8px" }}>(View projects)</span>
                </a>
              </div>
              <div className="ai-tile-right">
                <h3 className="ai-tile-title">AI Projects</h3>
                <p className="ai-tile-desc">
                 My work spans  LLMs, deep learning, Computer Vision, LangChain, BLIP, and 
                 multimodal AI, where I build end-to-end intelligent systems 
                 for real-world applications.<br/>
                <strong>Check it out on GitHub.</strong>
                </p>
              </div>
            </div>

            {/* Tile 2 — Coming Soon */}
            <div className="ai-tile">
              <div className="ai-tile-left">
                <div className="placeholder-pill">
                  🎮 &nbsp; Gaming
                </div>
              </div>
              <div className="ai-tile-right">
                <h3 className="ai-tile-title">AR/VR Game (Coming Soon)</h3>
                <p className="ai-tile-desc">
                  Immersive gaming experience combining AR/VR technologies with AI. 
                  <br/>Next-generation interactive gaming platform in development.
                  <br/>Stay tuned for the launch!
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="content-section contact-section" data-section="contact">
        <div className="section-card contact-shell">
          <h2 className="section-title contact-title">Get in touch! <br/></h2>
          <p fontSize = "1px">Ideas, collaborations, experiments, or just a good conversation.</p>
          <p fontSize="1px">Quickest way to contact: LinkedIn or fill out the form below and click "Send Message".</p>
          <div className="contact-layout">
            <div className="contact-left" style={{flex: 1}}>
              <a className="contact-card" href="mailto:arkind12345@gmail.com">
                <span className="contact-icon">✉️</span>
                <span className="contact-label">Email</span>
              </a>
              <a className="contact-card" href="https://www.linkedin.com/in/ar5sde/" target="_blank" rel="noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
                  <path fill="#0077b5" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                <span className="contact-label">LinkedIn</span>
              </a>
            </div>
            <div className="contact-right" style={{flex: 1}}>
              <div className="contact-form">
                <div className="form-group">
                  <label className="form-label">Your Name</label>
                  <input 
                    className="form-input" 
                    type="text" 
                    placeholder="e.g., Abc Carter"
                    value={contactName}
                    onChange={(e) => setContactName(e.target.value)}
                    disabled={contactLoading}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Your Email</label>
                  <input 
                    className="form-input" 
                    type="email" 
                    placeholder="e.g., abc@example.com"
                    value={contactEmail}
                    onChange={(e) => setContactEmail(e.target.value)}
                    disabled={contactLoading}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Your Message</label>
                  <textarea 
                    className="form-input form-textarea" 
                    placeholder="Hey, I'd love to connect..."
                    value={contactMessage}
                    onChange={(e) => setContactMessage(e.target.value)}
                    disabled={contactLoading}
                  />
                </div>
                <button
                  className="form-submit"
                  onClick={handleSendEmail}
                  disabled={contactLoading}
                >
                  {contactLoading ? "Sending..." : "Send Message"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}